<p-confirmDialog key="reportDeleteDialog" styleClass="report-delete-confirm-dialog" [style]="{ width: 'min(420px, 92vw)' }" />
<p-dialog
  [(visible)]="statusDialogVisible"
  [modal]="true"
  [showHeader]="false"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(400px, 92vw)' }"
  styleClass="status-confirm"
>
  <div
    class="status-confirm__card"
    [class.is-activate]="statusDialogMode === 'activate'"
    [class.is-move]="statusDialogMode === 'move'"
  >
      <span class="status-confirm__mark" aria-hidden="true">
      <i
        class="pi"
        [ngClass]="statusDialogMode === 'activate' ? 'pi-user-plus' : statusDialogMode === 'move' ? 'pi-arrow-right' : 'pi-user-minus'"
      ></i>
    </span>
    <h2>{{ statusDialogTitle }}</h2>
    <p>{{ statusDialogDetail }}</p>
    <div class="status-confirm__actions">
      <button type="button" class="status-confirm__cancel" (click)="closeStatusDialog()">Cancel</button>
      <button type="button" class="status-confirm__go" (click)="acceptStatusDialog()">
        {{ statusDialogMode === 'activate' ? 'Activate' : statusDialogMode === 'move' ? 'Move visits' : 'Deactivate' }}
      </button>
    </div>
  </div>
</p-dialog>

<div class="container-fluid patient-page">
  <app-work-context-bar />

  <div class="patient-shell">
    <section class="patient-toolbar">
      <div class="toolbar-top">
        <div class="toolbar-title">
          <h5 class="mb-0">Patient Registration</h5>
          <small *ngIf="!showDuplicates">{{ totalRecords }} record(s)</small>
          <small *ngIf="showDuplicates">{{ duplicatePatientCount }} duplicate patient(s)</small>
        </div>
        <div class="toolbar-actions">
          <button
            type="button"
            class="btn dup-btn"
            [class.is-on]="showDuplicates"
            (click)="toggleDuplicates()"
          >
            <i class="pi pi-copy me-1"></i>
            Duplicates
            <span class="dup-count" *ngIf="duplicatePatientCount">{{ duplicatePatientCount }}</span>
          </button>
          <button type="button" class="btn add-btn" (click)="startAdd()">
            <i class="pi pi-plus me-1"></i>
            Add Patient
          </button>
        </div>
      </div>

      <div class="toolbar-controls">
        <div class="search-wrap">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="form-control"
            placeholder="Search name, patient no, contact, email..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
          />
        </div>

        <div class="filter-dropdown-wrap" *ngIf="!showDuplicates">
          <p-dropdown
            [options]="statusFilterOptions"
            [(ngModel)]="statusFilter"
            optionLabel="label"
            optionValue="value"
            (onChange)="onFilterDropdownChange($event, 'statusFilter')"
            styleClass="toolbar-filter-dropdown"
            panelStyleClass="toolbar-filter-panel"
            appendTo="body"
          />
        </div>

        <div class="filter-dropdown-wrap" *ngIf="!showDuplicates">
          <p-dropdown
            [options]="clinicFilterOptions"
            [(ngModel)]="clinicFilter"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            (onChange)="onFilterDropdownChange($event, 'clinicFilter')"
            styleClass="toolbar-filter-dropdown"
            panelStyleClass="toolbar-filter-panel"
            appendTo="body"
          />
        </div>

        <div class="filter-dropdown-wrap" *ngIf="!showDuplicates">
          <p-dropdown
            [options]="freePatientFilterOptions"
            [(ngModel)]="freePatientFilter"
            optionLabel="label"
            optionValue="value"
            (onChange)="onFilterDropdownChange($event, 'freePatientFilter')"
            styleClass="toolbar-filter-dropdown"
            panelStyleClass="toolbar-filter-panel"
            appendTo="body"
          />
        </div>

        <button type="button" class="btn btn-outline-secondary reset-btn" *ngIf="!showDuplicates" (click)="clearFilters()">
          <i class="pi pi-filter-slash me-1"></i>
          Reset
        </button>
      </div>
    </section>

    <section class="patient-table-card" *ngIf="!showDuplicates">
      <div class="table-responsive">
        <table class="table modern-table mb-0">
          <thead>
            <tr>
              <th>Patient</th>
              <th>Patient No.</th>
              <th>Contact</th>
              <th>Age</th>
              <th>Clinic</th>
              <th class="free-cell">Free Patient</th>
              <th>Status</th>
              <th class="action-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="8" class="text-center py-4 text-muted">Loading patients...</td>
            </tr>

            <ng-container *ngIf="!isLoading">
              <ng-container *ngFor="let item of patientList">
                <ng-container *ngTemplateOutlet="patientRow; context: { $implicit: item }"></ng-container>
              </ng-container>

              <tr *ngIf="patientList.length === 0">
                <td colspan="8" class="text-center py-4 empty-state">
                  <i class="pi pi-inbox d-block mb-2"></i>
                  No patients found.
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="table-pagination" *ngIf="totalRecords > 0">
        <div class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }} · {{ totalRecords }} total
        </div>
        <div class="pagination-controls">
          <select class="form-select form-select-sm" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / page</option>
          </select>
          <button type="button" class="page-btn" [disabled]="currentPage <= 1" (click)="goToPreviousPage()">
            <i class="pi pi-chevron-left"></i>
          </button>
          <button
            type="button"
            class="page-btn"
            *ngFor="let page of visiblePageNumbers"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
          <button type="button" class="page-btn" [disabled]="currentPage >= totalPages" (click)="goToNextPage()">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>

    <section class="dup-panel" *ngIf="showDuplicates">
      <div class="dup-bar" *ngIf="!duplicatesLoading" [class.has-selection]="selectedDuplicateIds.length">
        <div class="dup-bar__lead">
          <span class="dup-bar__num">{{ selectedDuplicateIds.length }}</span>
          <span>selected to deactivate</span>
        </div>
        <div class="dup-bar__actions">
          <button
            type="button"
            class="dup-deactivate"
            [disabled]="!selectedDuplicateIds.length || deactivatingDuplicates"
            (click)="confirmDeactivateSelected()"
          >
            <i class="pi pi-user-minus"></i>
            Deactivate
          </button>
          <button
            type="button"
            class="dup-clear"
            [disabled]="!selectedDuplicateIds.length"
            (click)="clearDuplicateSelection()"
          >
            Clear
          </button>
        </div>
      </div>

      <p class="dup-loading" *ngIf="duplicatesLoading">Loading duplicate patients...</p>

      <div class="dup-list" *ngIf="!duplicatesLoading">
        <article class="dup-card" *ngFor="let group of pagedDuplicateGroups" [class.is-open]="isDuplicateGroupOpen(group)">
          <header class="dup-card__head">
            <button type="button" class="dup-card__title" (click)="toggleDuplicateGroup(group)">
              <i class="pi" [ngClass]="isDuplicateGroupOpen(group) ? 'pi-chevron-down' : 'pi-chevron-right'" aria-hidden="true"></i>
              <span>{{ group.label }}</span>
              <em>{{ group.patients.length }} records</em>
            </button>
            <div class="dup-reasons">
              <span class="dup-reason" *ngFor="let reason of group.reasons">{{ duplicateReasonLabel(reason) }}</span>
            </div>
            <label class="dup-select">
              <input
                type="checkbox"
                [checked]="isGroupFullySelected(group)"
                [disabled]="groupActiveCount(group) === 0"
                (change)="toggleGroupSelection(group, $event)"
              />
              Select copies
            </label>
          </header>

          <div class="dup-people" *ngIf="!isDuplicateGroupOpen(group)">
            <div class="dup-person dup-person--keep" *ngIf="primaryPatient(group) as keep">
              <span class="dup-person__tag">Keep</span>
              <div class="dup-person__id">
                <span class="dup-person__name">{{ getDisplayName(keep) }}</span>
                <span class="dup-person__meta">{{ patientGlance(keep) }}</span>
              </div>
              <ng-container *ngTemplateOutlet="visitCounts; context: { $implicit: keep }"></ng-container>
            </div>
            <div class="dup-person dup-person--copy" *ngFor="let copy of previewCopies(group)">
              <span class="dup-person__tag">Copy</span>
              <div class="dup-person__id">
                <span class="dup-person__name">{{ getDisplayName(copy) }}</span>
                <span class="dup-person__meta">{{ patientGlance(copy) }}</span>
              </div>
              <ng-container *ngTemplateOutlet="visitCounts; context: { $implicit: copy }"></ng-container>
              <button
                type="button"
                class="dup-move"
                *ngIf="canMoveVisits(copy)"
                [disabled]="movingVisits"
                (click)="confirmMoveVisits(copy, $event)"
              >
                Move to kept record
              </button>
            </div>
            <button
              type="button"
              class="dup-more"
              *ngIf="hiddenCopyCount(group) > 0"
              (click)="toggleDuplicateGroup(group)"
            >
              {{ hiddenCopyCount(group) }} more {{ hiddenCopyCount(group) === 1 ? 'copy' : 'copies' }}
            </button>
          </div>

          <div class="dup-card__body" *ngIf="isDuplicateGroupOpen(group)">
            <div class="table-responsive">
              <table class="table modern-table mb-0">
                <thead>
                  <tr>
                    <th class="dup-check-cell"></th>
                    <th>Patient</th>
                    <th>Patient No.</th>
                    <th>Contact</th>
                    <th>Age</th>
                    <th>Clinic</th>
                    <th class="free-cell">Free Patient</th>
                    <th>Status</th>
                    <th class="action-cell">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of group.patients">
                    <ng-container *ngTemplateOutlet="patientRow; context: { $implicit: item, selectable: true }"></ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </article>

        <p class="dup-empty" *ngIf="visibleDuplicateGroups.length === 0">
          <i class="pi pi-check-circle"></i>
          No duplicate patients.
        </p>
      </div>

      <div class="table-pagination" *ngIf="!duplicatesLoading && visibleDuplicateGroups.length > 0">
        <div class="pagination-info">
          Page {{ duplicatePageSafe }} of {{ duplicateTotalPages }} · {{ visibleDuplicateGroups.length }} groups
        </div>
        <div class="pagination-controls">
          <select class="form-select form-select-sm" style="width: auto" [(ngModel)]="duplicatePageSize" (ngModelChange)="onDuplicatePageSizeChanged()">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / page</option>
          </select>
          <button type="button" class="page-btn" [disabled]="duplicatePageSafe <= 1" (click)="goToDuplicatePage(duplicatePageSafe - 1)">
            <i class="pi pi-chevron-left"></i>
          </button>
          <button
            type="button"
            class="page-btn"
            *ngFor="let page of duplicateVisiblePages"
            [class.active]="page === duplicatePageSafe"
            (click)="goToDuplicatePage(page)"
          >
            {{ page }}
          </button>
          <button type="button" class="page-btn" [disabled]="duplicatePageSafe >= duplicateTotalPages" (click)="goToDuplicatePage(duplicatePageSafe + 1)">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #patientRow let-item let-selectable="selectable">
  <tr [class.dup-row-primary]="selectable && item.is_primary" [class.dup-row-copy]="selectable && !item.is_primary">
    <td *ngIf="selectable" class="dup-check-cell">
      <input
        type="checkbox"
        [checked]="isDuplicateSelected(item)"
        [disabled]="!isPatientActive(item) || deactivatingDuplicates"
        (change)="toggleDuplicateSelection(item, $event)"
        [attr.aria-label]="'Select ' + getDisplayName(item)"
      />
    </td>
    <td>
      <div class="patient-cell">
        <span class="patient-avatar">{{ getPatientInitial(item) }}</span>
        <div class="patient-meta">
          <span class="patient-name">
            {{ getDisplayName(item) }}
            <span class="dup-role dup-role--primary" *ngIf="selectable && item.is_primary">Keep</span>
            <span class="dup-role dup-role--copy" *ngIf="selectable && !item.is_primary">Copy</span>
          </span>
          <small>{{ item.email || '—' }}</small>
        </div>
      </div>
    </td>
    <td>
      {{ item.patient_number || '—' }}
      <small class="dup-old-card" *ngIf="item.old_card_number">Old card {{ item.old_card_number }}</small>
      <ng-container *ngIf="selectable" [ngTemplateOutlet]="visitCounts" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
    </td>
    <td>{{ item.contact_number || '—' }}</td>
    <td>{{ formatAge(item) }}</td>
    <td>{{ item.clinic_name || '—' }}</td>
    <td class="free-cell">
      <span class="status-chip" [ngClass]="getFreePatientClass(item)">
        {{ isFreePatient(item) ? 'Free' : 'Paid' }}
      </span>
    </td>
    <td>
      <span class="status-chip" [ngClass]="getStatusClass(item)">
        {{ isPatientActive(item) ? 'Active' : 'Inactive' }}
      </span>
    </td>
    <td class="action-cell">
      <div class="action-buttons">
        <button type="button" class="table-action-btn edit-btn" (click)="startEdit(item)" title="Edit patient">
          <i class="pi pi-pencil"></i>
        </button>
        <button type="button" class="table-action-btn upload-btn" (click)="openUploadDialog(item)" title="Upload reports">
          <i class="pi pi-upload"></i>
        </button>
        <button
          type="button"
          class="dup-move"
          *ngIf="selectable && canMoveVisits(item)"
          [disabled]="movingVisits"
          (click)="confirmMoveVisits(item, $event)"
          title="Move appointments and prescriptions to the kept record"
        >
          Move
        </button>
        <button
          type="button"
          class="table-action-btn toggle-btn"
          (click)="confirmToggleStatus(item)"
          [title]="isPatientActive(item) ? 'Deactivate patient' : 'Activate patient'"
        >
          <i class="pi pi-refresh"></i>
        </button>
      </div>
    </td>
  </tr>
</ng-template>

<ng-template #visitCounts let-item>
  <span class="dup-counts" *ngIf="hasVisitStats(item)">
    <span class="dup-count-pill">
      <strong>{{ visitCount(item) }}</strong>
      {{ visitCount(item) === 1 ? 'visit' : 'visits' }}
    </span>
    <span class="dup-count-pill dup-count-pill--rx" [class.is-empty]="prescriptionCount(item) === 0">
      <strong>{{ prescriptionCount(item) }}</strong>
      Rx
    </span>
  </span>
</ng-template>

<p-dialog
  [header]="patient.id ? 'Edit Patient' : 'Register Patient'"
  [(visible)]="showForm"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="1400"
  [autoZIndex]="true"
  [style]="{ width: '80vw', maxWidth: '1100px' }"
  [breakpoints]="{ '1200px': '98vw', '768px': '100vw' }"
  styleClass="patient-form-dialog"
  [contentStyle]="{ 'max-height': '78vh', overflow: 'auto', padding: '1rem 1.15rem' }"
  (onHide)="closeForm()"
>
  <form class="patient-dialog-form pr-register-form" #patientForm="ngForm">
    <div class="pr-modal-grid">
      <section class="pr-section-card">
        <header class="pr-section-head pr-section-head--personal">
          <span class="pr-section-icon" aria-hidden="true"><i class="pi pi-user"></i></span>
          <h6>Personal Details</h6>
        </header>

        <div class="pr-field">
          <label class="pr-field-label" for="full_name">Full Name <span class="text-danger">*</span></label>
          <input
            id="full_name"
            type="text"
            name="full_name"
            class="form-control pr-input"
            placeholder="Patient name"
            [(ngModel)]="patient.full_name"
            (ngModelChange)="onDuplicateFieldsChanged()"
            required
          />
        </div>

        <div class="pr-field-row">
          <div class="pr-field">
            <label class="pr-field-label">Age <span class="text-danger">*</span></label>
            <app-patient-age-fields
              [(years)]="patient.age"
              [(months)]="patient.age_months"
              [(days)]="patient.age_days"
            ></app-patient-age-fields>
          </div>
          <div class="pr-field">
            <label class="pr-field-label" for="old_card_number">Old Card No.</label>
            <input
              id="old_card_number"
              type="text"
              name="old_card_number"
              class="form-control pr-input"
              placeholder="Enter old card"
              [(ngModel)]="patient.old_card_number"
            />
          </div>
        </div>

        <div class="pr-field">
          <div class="pr-contact-label-row">
            <label class="pr-field-label" for="contact_number">Contact Number <span class="text-danger">*</span></label>
            <button
              type="button"
              class="foreign-contact-chip"
              [class.is-active]="isForeignContact"
              (click)="toggleForeignContact()"
            >
              <i class="pi" [ngClass]="isForeignContact ? 'pi-check-square' : 'pi-stop'"></i>
              Foreign number
            </button>
          </div>

          <ng-container *ngIf="!isForeignContact; else foreignContactBlock">
            <input
              id="contact_number"
              type="tel"
              inputmode="numeric"
              maxlength="10"
              pattern="[0-9]*"
              autocomplete="tel"
              name="contact_number"
              class="form-control pr-input"
              placeholder="10-digit mobile"
              [(ngModel)]="patient.contact_number"
              (input)="onContactNumberInput($event)"
            />
          </ng-container>

          <ng-template #foreignContactBlock>
            <div class="pr-phone-row">
              <p-dropdown
                inputId="dial_code"
                name="dial_code"
                [options]="dialCodeOptions"
                [(ngModel)]="selectedDialCode"
                (onChange)="onDialCodeChange()"
                optionLabel="label"
                optionValue="value"
                placeholder="Code"
                [filter]="true"
                filterBy="label,value"
                appendTo="body"
                styleClass="pr-dial-code"
                panelStyleClass="pr-dial-code-panel location-dropdown-panel"
              ></p-dropdown>
              <input
                id="contact_number"
                type="tel"
                inputmode="numeric"
                [maxlength]="foreignNationalMaxLength"
                pattern="[0-9]*"
                autocomplete="tel-national"
                name="contact_number_foreign"
                class="form-control pr-input"
                placeholder="Phone number"
                [(ngModel)]="foreignNationalNumber"
                (input)="onForeignNationalInput($event)"
              />
            </div>
            <small class="pr-field-hint">Saved as {{ composedForeignContact || 'country code + number' }}</small>
          </ng-template>
        </div>

        <div class="pr-field">
          <label class="pr-field-label" for="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            class="form-control pr-input"
            placeholder="hello@gmail.com"
            [(ngModel)]="patient.email"
          />
        </div>
      </section>

      <section class="pr-section-card">
        <header class="pr-section-head pr-section-head--location">
          <span class="pr-section-icon" aria-hidden="true"><i class="pi pi-map-marker"></i></span>
          <h6>Location</h6>
        </header>

        <div class="pr-field">
          <label class="pr-field-label" for="address">Address</label>
          <textarea
            id="address"
            name="address"
            class="form-control pr-input"
            rows="2"
            placeholder="Street address"
            [(ngModel)]="patient.address"
          ></textarea>
        </div>

        <div class="pr-field-row">
          <div class="pr-field">
            <label class="pr-field-label" for="country">Country</label>
            <p-dropdown
              inputId="country"
              name="country"
              [options]="countryOptions"
              [(ngModel)]="patient.country"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              [filter]="true"
              filterBy="label"
              filterPlaceholder="Search country..."
              appendTo="body"
              styleClass="w-100 location-control"
              panelStyleClass="location-dropdown-panel"
              (onChange)="onCountryChange()"
            ></p-dropdown>
          </div>
          <div class="pr-field">
            <label class="pr-field-label" for="state">State</label>
            <p-dropdown
              *ngIf="!useManualStateInput"
              inputId="state"
              name="state"
              [options]="stateOptions"
              [(ngModel)]="patient.state"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              [filter]="true"
              filterBy="label"
              filterPlaceholder="Search state..."
              appendTo="body"
              styleClass="w-100 location-control"
              panelStyleClass="location-dropdown-panel"
              (onChange)="onStateChange()"
            ></p-dropdown>
            <input
              *ngIf="useManualStateInput"
              id="state"
              type="text"
              name="state"
              class="form-control pr-input"
              placeholder="State"
              [(ngModel)]="patient.state"
            />
          </div>
        </div>

        <div class="pr-field-row">
          <div class="pr-field">
            <label class="pr-field-label" for="city">City</label>
            <p-dropdown
              *ngIf="!useManualCityInput"
              inputId="city"
              name="city"
              [options]="cityOptions"
              [(ngModel)]="patient.city"
              optionLabel="label"
              optionValue="value"
              placeholder="Select"
              [filter]="true"
              filterBy="label"
              filterPlaceholder="Search city..."
              appendTo="body"
              styleClass="w-100 location-control"
              panelStyleClass="location-dropdown-panel"
              (onChange)="onCityChange()"
            ></p-dropdown>
            <input
              *ngIf="useManualCityInput"
              id="city"
              type="text"
              name="city"
              class="form-control pr-input"
              placeholder="City"
              [(ngModel)]="patient.city"
            />
          </div>
          <div class="pr-field">
            <label class="pr-field-label" for="pincode">Pincode</label>
            <input
              id="pincode"
              type="text"
              name="pincode"
              class="form-control pr-input"
              placeholder="e.g. 110001"
              [(ngModel)]="patient.pincode"
            />
          </div>
        </div>
      </section>

      <section class="pr-section-card">
        <header class="pr-section-head pr-section-head--clinic">
          <span class="pr-section-icon" aria-hidden="true"><i class="pi pi-building"></i></span>
          <h6>Clinic Info</h6>
        </header>

        <button
          type="button"
          class="free-patient-chip"
          [class.is-active]="patient.is_free"
          (click)="patient.is_free = !patient.is_free"
        >
          <i class="pi" [ngClass]="patient.is_free ? 'pi-check-square' : 'pi-stop'"></i>
          Free Patient
        </button>

        <div class="pr-field">
          <label class="pr-field-label" for="under_dr">Under Doctor</label>
          <p-dropdown
            inputId="under_dr"
            name="under_dr"
            [options]="doctorsList"
            [(ngModel)]="patient.under_dr"
            optionLabel="label"
            optionValue="label"
            placeholder="Select Doctor"
            appendTo="body"
            styleClass="w-100 location-control"
          ></p-dropdown>
        </div>

        <div class="pr-field">
          <label class="pr-field-label" for="clinic">Clinic <span class="text-danger">*</span></label>
          <p-dropdown
            inputId="clinic"
            name="clinic"
            [options]="clinicList"
            [(ngModel)]="patient.clinic_id"
            optionLabel="label"
            optionValue="value"
            placeholder="Select Clinic"
            appendTo="body"
            styleClass="w-100 location-control"
          ></p-dropdown>
        </div>
      </section>
    </div>

    <section class="pr-section-card pr-section-card--wide card-assignment-panel">
      <header class="pr-section-head pr-section-head--card">
        <span class="pr-section-icon" aria-hidden="true"><i class="pi pi-id-card"></i></span>
        <div>
          <h6>Card Assignment</h6>
          <p class="pr-section-subtitle mb-0">Create a new card or assign this patient to an existing one</p>
        </div>
      </header>

      <div class="card-mode-options">
        <button
          type="button"
          class="card-mode-option"
          [class.active]="isNewPatient"
          (click)="setCardMode(true)"
        >
          <i class="pi pi-plus-circle" aria-hidden="true"></i>
          <span class="card-mode-title">Create New Card</span>
          <small>Auto-generate a card for this patient</small>
        </button>
        <button
          type="button"
          class="card-mode-option"
          [class.active]="!isNewPatient"
          (click)="setCardMode(false)"
        >
          <i class="pi pi-search" aria-hidden="true"></i>
          <span class="card-mode-title">Use Existing Card</span>
          <small>Search and assign to a family card</small>
        </button>
      </div>

      <div class="create-card-panel" *ngIf="isNewPatient">
        <span class="create-card-icon" aria-hidden="true"><i class="pi pi-plus"></i></span>
        <div>
          <div class="create-card-title">New card will be generated automatically</div>
          <div class="create-card-copy">You do not need to enter a card number when creating a new card.</div>
        </div>
      </div>

      <div class="row g-3 align-items-stretch" *ngIf="!isNewPatient">
        <div class="col-lg-7">
          <label class="pr-field-label" for="card">Search Card Number</label>
          <p-autoComplete
            [delay]="300"
            inputId="card"
            name="card"
            [(ngModel)]="selectedCard"
            [suggestions]="filteredCardList"
            (completeMethod)="searchCards($event)"
            (onSelect)="onCardSelect($event)"
            field="label"
            placeholder="Search by card number or patient name"
            [forceSelection]="true"
            emptyMessage="No cards found"
            styleClass="w-100 card-autocomplete"
            inputStyleClass="card-autocomplete-input pr-input"
            appendTo="body"
          >
            <ng-template let-item pTemplate="item">
              <div class="card-suggestion">
                <div class="card-suggestion-head">
                  <span class="card-suggestion-number">{{ item.number || item.label }}</span>
                  <span class="card-suggestion-count">{{ item.patientCount }} patient{{ item.patientCount === 1 ? '' : 's' }}</span>
                </div>
                <div class="card-suggestion-patients" *ngIf="item.patients?.length; else noPatientsOnSuggestion">
                  <div class="card-suggestion-patient" *ngFor="let cardPatient of item.patients">
                    <span class="card-suggestion-patient-name">{{ cardPatient.full_name }}</span>
                    <span class="card-suggestion-patient-meta" *ngIf="cardPatient.patient_number">{{ cardPatient.patient_number }}</span>
                  </div>
                </div>
                <ng-template #noPatientsOnSuggestion>
                  <div class="card-suggestion-empty">No patients on this card yet</div>
                </ng-template>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>

        <div class="col-lg-5">
          <div class="selected-card-patients h-100" *ngIf="selectedCard; else selectCardPrompt">
            <div class="selected-card-patients-head">
              <strong>Patients on Card</strong>
              <span class="text-muted">{{ selectedCardPatients.length }} linked</span>
            </div>
            <div class="selected-card-patients-list" *ngIf="selectedCardPatients.length; else noLinkedPatients">
              <div class="selected-card-patient-row" *ngFor="let cardPatient of selectedCardPatients">
                <span class="selected-card-patient-name">{{ cardPatient.full_name }}</span>
                <span class="selected-card-patient-meta" *ngIf="cardPatient.patient_number">{{ cardPatient.patient_number }}</span>
              </div>
            </div>
            <ng-template #noLinkedPatients>
              <div class="selected-card-patients-empty">No patients linked to this card yet.</div>
            </ng-template>
          </div>
          <ng-template #selectCardPrompt>
            <div class="select-card-prompt h-100">
              <i class="pi pi-id-card" aria-hidden="true"></i>
              <span>Search and select a card to view its patients</span>
            </div>
          </ng-template>
        </div>
      </div>
    </section>

    <div class="duplicate-warning mt-2" *ngIf="duplicateWarning">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      {{ duplicateWarning }}
    </div>
    <div class="duplicate-check-status mt-2" *ngIf="isCheckingDuplicate">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      Checking for duplicates...
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-actions">
      <button type="button" class="btn btn-cancel-outline" (click)="closeForm()">
        <i class="pi pi-times me-1"></i>
        Cancel
      </button>
      <button type="button" class="btn btn-submit-teal" [disabled]="!canSubmitPatientForm || isCheckingDuplicate" (click)="processPatient()">
        <i class="pi pi-check me-1"></i>
        {{ patient.id ? 'Update Patient' : 'Add Patient' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Reports & Documents"
  [(visible)]="openUploadReportDialog"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: 'min(1100px, 96vw)' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="report-upload-dialog"
>
  <div class="reports-shell">
    <div class="reports-topbar">
      <div>
        <div class="reports-title">{{ currentPatientName || 'Patient Reports' }}</div>
        <div class="reports-subtitle">Upload medical documents, lab reports, and images</div>
      </div>
      <div class="reports-metrics">
        <span class="report-metric-pill">
          <i class="pi pi-folder-open"></i>
          {{ totalReportsCount }} saved
        </span>
        <span class="report-metric-pill pending" *ngIf="pendingFiles.length">
          <i class="pi pi-clock"></i>
          {{ pendingFiles.length }} pending · {{ selectedUploadSizeLabel }}
        </span>
      </div>
    </div>

    <div class="reports-body-split">
      <aside class="reports-upload-col">
        <div class="reports-upload-panel">
          <div class="reports-upload-head reports-upload-head--stacked">
            <div>
              <div class="reports-upload-title">Upload documents / images</div>
              <div class="reports-upload-hint">PDF, JPG, PNG · Max 20 MB per file</div>
            </div>
          </div>

          <div
            class="reports-dropzone"
            [class.is-dragover]="isReportDragOver"
            (dragover)="onReportDragOver($event)"
            (dragleave)="onReportDragLeave($event)"
            (drop)="onReportDrop($event)"
            (click)="reportFileInput.click()"
          >
            <input
              #reportFileInput
              type="file"
              class="reports-file-input-hidden"
              multiple
              accept="image/png,image/jpeg,image/jpg,application/pdf"
              (change)="onFileSelect($event)"
              (click)="$event.stopPropagation()"
            />
            <div class="reports-dropzone-icon-wrap">
              <i class="pi pi-cloud-upload reports-dropzone-icon"></i>
            </div>
            <h6 class="reports-dropzone-title">Drag & drop files here</h6>
            <p class="reports-dropzone-text">or click to browse</p>
          </div>

          <div class="pending-file-list" *ngIf="pendingFiles.length" (click)="$event.stopPropagation()">
            <span class="pending-file-chip" *ngFor="let file of pendingFiles; let i = index">
              <i class="pi" [ngClass]="file.type === 'application/pdf' ? 'pi-file-pdf' : 'pi-image'"></i>
              <span>{{ file.name }}</span>
              <button type="button" class="pending-file-remove" (click)="removePendingFile(i)" title="Remove file">
                <i class="pi pi-times"></i>
              </button>
            </span>
          </div>

          <button
            type="button"
            class="reports-upload-btn reports-upload-btn--block"
            [disabled]="!pendingFiles.length || isUploadingReports"
            (click)="onUploadSelectedFiles()"
          >
            <i class="pi" [ngClass]="isUploadingReports ? 'pi-spin pi-spinner' : 'pi-cloud-upload'"></i>
            {{ isUploadingReports ? 'Uploading...' : 'Upload files' }}
          </button>
        </div>
      </aside>

      <section class="reports-gallery-col">
        <div class="reports-gallery" *ngIf="uploadsByDate.length; else noUploads">
          <div *ngFor="let group of uploadsByDate" class="report-date-group">
            <div class="report-date-head">
              <span class="report-date-label">
                <i class="pi pi-calendar"></i>
                {{ getReportDateLabel(group.date) }}
              </span>
              <span class="report-date-count">{{ group.files.length || 0 }} file(s)</span>
            </div>

            <div class="report-card-grid">
              <article
                *ngFor="let file of group.files"
                class="report-file-card"
                (click)="openFile(file, $event)"
              >
                <button
                  type="button"
                  class="report-delete-icon"
                  [disabled]="deletingReportId === file.id"
                  (click)="deleteReport(file, $event)"
                  title="Delete report"
                >
                  <i class="pi" [ngClass]="deletingReportId === file.id ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
                </button>

                <div class="report-preview">
                  <img
                    *ngIf="file.type?.startsWith('image/'); else docPreview"
                    [src]="reportFileUrl(file)"
                    class="report-preview-image"
                    [alt]="file.name"
                  />
                  <ng-template #docPreview>
                    <i class="pi pi-file-pdf report-preview-doc"></i>
                  </ng-template>
                </div>

                <div class="report-file-body">
                  <div class="report-file-name" [title]="file.name">{{ file.name }}</div>
                  <div class="report-file-meta">
                    <span class="report-file-type">{{ getReportTypeLabel(file) }}</span>
                    <span class="report-file-time">{{ file.uploaded_at | date: 'shortTime' }}</span>
                  </div>
                  <div class="report-file-submeta" *ngIf="file.size">{{ formatFileSize(file.size) }}</div>
                </div>
              </article>
            </div>
          </div>
        </div>

        <ng-template #noUploads>
          <div class="reports-empty-state">
            <i class="pi pi-inbox"></i>
            <h6>No reports uploaded yet</h6>
            <p>Upload files from the panel on the left. Saved reports will appear here grouped by date.</p>
          </div>
        </ng-template>
      </section>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn reports-close-btn" (click)="closeUploadReportDialog()">Close</button>
  </ng-template>
</p-dialog>

<app-report-viewer-dialog
  [(visible)]="reportViewerVisible"
  [loading]="reportViewerLoading"
  [title]="reportViewerTitle"
  [isImage]="reportViewerIsImage"
  [imageUrl]="reportViewerImageUrl"
  [documentUrl]="reportViewerDocumentUrl"
  [rawUrl]="reportViewerRawUrl"
  [errorMessage]="reportViewerError"
  (closed)="closeReportViewer()"
></app-report-viewer-dialog>
